/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One admission's demographics as read from MatrixCare.
 * @export
 * @interface MatrixCareAdmissionDemographics
 */
export interface MatrixCareAdmissionDemographics {
    /**
     * 
     */
    first_name?: string | null;
    /**
     * 
     */
    middle_name?: string | null;
    /**
     * 
     */
    last_name?: string | null;
    /**
     * 
     */
    suffix?: string | null;
    /**
     * 
     */
    nickname?: string | null;
    /**
     * 
     */
    preferred_pronouns?: string | null;
    /**
     * 
     */
    medical_record?: string | null;
    /**
     * 
     */
    formatted_ssn?: string | null;
    /**
     * MatrixCare wire format, M/D/YYYY.
     */
    date_of_birth?: string | null;
    /**
     * 
     */
    address_line?: string | null;
    /**
     * 
     */
    apt_or_suite?: string | null;
    /**
     * 
     */
    city?: string | null;
    /**
     * 
     */
    state_code?: string | null;
    /**
     * 
     */
    zip_code?: string | null;
    /**
     * 
     */
    country?: string | null;
    /**
     * 
     */
    email?: string | null;
    /**
     * 
     */
    home_phone?: string | null;
    /**
     * 
     */
    mobile_phone?: string | null;
    /**
     * 
     */
    gender?: string | null;
    /**
     * 
     */
    gender_identity?: string | null;
    /**
     * 
     */
    sexual_orientation?: string | null;
    /**
     * 
     */
    lives_alone?: string | null;
    /**
     * 
     */
    marital_status?: string | null;
    /**
     * 
     */
    religion?: string | null;
    /**
     * 
     */
    races: Array<string>;
    /**
     * 
     */
    ethnicities: Array<string>;
    /**
     * 
     */
    referral_date?: string | null;
    /**
     * 
     */
    scheduled_soc_date?: string | null;
    /**
     * 
     */
    physician_ordered_soc_date?: string | null;
    /**
     * 
     */
    facility_discharge_date?: string | null;
    /**
     * 
     */
    facility_discharge_type?: string | null;
    /**
     * 
     */
    referral_source?: string | null;
    /**
     * 
     */
    is_short_stay_acute_hospital?: boolean | null;
    /**
     * 
     */
    for_observation_only?: boolean | null;
}

/**
 * Check if a given object implements the MatrixCareAdmissionDemographics interface.
 */
export function instanceOfMatrixCareAdmissionDemographics(value: object): value is MatrixCareAdmissionDemographics {
    if (!('races' in value) || value['races'] === undefined) return false;
    if (!('ethnicities' in value) || value['ethnicities'] === undefined) return false;
    return true;
}

export function MatrixCareAdmissionDemographicsFromJSON(json: any): MatrixCareAdmissionDemographics {
    return MatrixCareAdmissionDemographicsFromJSONTyped(json, false);
}

export function MatrixCareAdmissionDemographicsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCareAdmissionDemographics {
    if (json == null) {
        return json;
    }
    return {
        
        'first_name': json['first_name'] === undefined ? undefined : json['first_name'] === null ? null : json['first_name'],
        'middle_name': json['middle_name'] === undefined ? undefined : json['middle_name'] === null ? null : json['middle_name'],
        'last_name': json['last_name'] === undefined ? undefined : json['last_name'] === null ? null : json['last_name'],
        'suffix': json['suffix'] === undefined ? undefined : json['suffix'] === null ? null : json['suffix'],
        'nickname': json['nickname'] === undefined ? undefined : json['nickname'] === null ? null : json['nickname'],
        'preferred_pronouns': json['preferred_pronouns'] === undefined ? undefined : json['preferred_pronouns'] === null ? null : json['preferred_pronouns'],
        'medical_record': json['medical_record'] === undefined ? undefined : json['medical_record'] === null ? null : json['medical_record'],
        'formatted_ssn': json['formatted_ssn'] === undefined ? undefined : json['formatted_ssn'] === null ? null : json['formatted_ssn'],
        'date_of_birth': json['date_of_birth'] === undefined ? undefined : json['date_of_birth'] === null ? null : json['date_of_birth'],
        'address_line': json['address_line'] === undefined ? undefined : json['address_line'] === null ? null : json['address_line'],
        'apt_or_suite': json['apt_or_suite'] === undefined ? undefined : json['apt_or_suite'] === null ? null : json['apt_or_suite'],
        'city': json['city'] === undefined ? undefined : json['city'] === null ? null : json['city'],
        'state_code': json['state_code'] === undefined ? undefined : json['state_code'] === null ? null : json['state_code'],
        'zip_code': json['zip_code'] === undefined ? undefined : json['zip_code'] === null ? null : json['zip_code'],
        'country': json['country'] === undefined ? undefined : json['country'] === null ? null : json['country'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'home_phone': json['home_phone'] === undefined ? undefined : json['home_phone'] === null ? null : json['home_phone'],
        'mobile_phone': json['mobile_phone'] === undefined ? undefined : json['mobile_phone'] === null ? null : json['mobile_phone'],
        'gender': json['gender'] === undefined ? undefined : json['gender'] === null ? null : json['gender'],
        'gender_identity': json['gender_identity'] === undefined ? undefined : json['gender_identity'] === null ? null : json['gender_identity'],
        'sexual_orientation': json['sexual_orientation'] === undefined ? undefined : json['sexual_orientation'] === null ? null : json['sexual_orientation'],
        'lives_alone': json['lives_alone'] === undefined ? undefined : json['lives_alone'] === null ? null : json['lives_alone'],
        'marital_status': json['marital_status'] === undefined ? undefined : json['marital_status'] === null ? null : json['marital_status'],
        'religion': json['religion'] === undefined ? undefined : json['religion'] === null ? null : json['religion'],
        'races': json['races'],
        'ethnicities': json['ethnicities'],
        'referral_date': json['referral_date'] === undefined ? undefined : json['referral_date'] === null ? null : json['referral_date'],
        'scheduled_soc_date': json['scheduled_soc_date'] === undefined ? undefined : json['scheduled_soc_date'] === null ? null : json['scheduled_soc_date'],
        'physician_ordered_soc_date': json['physician_ordered_soc_date'] === undefined ? undefined : json['physician_ordered_soc_date'] === null ? null : json['physician_ordered_soc_date'],
        'facility_discharge_date': json['facility_discharge_date'] === undefined ? undefined : json['facility_discharge_date'] === null ? null : json['facility_discharge_date'],
        'facility_discharge_type': json['facility_discharge_type'] === undefined ? undefined : json['facility_discharge_type'] === null ? null : json['facility_discharge_type'],
        'referral_source': json['referral_source'] === undefined ? undefined : json['referral_source'] === null ? null : json['referral_source'],
        'is_short_stay_acute_hospital': json['is_short_stay_acute_hospital'] === undefined ? undefined : json['is_short_stay_acute_hospital'] === null ? null : json['is_short_stay_acute_hospital'],
        'for_observation_only': json['for_observation_only'] === undefined ? undefined : json['for_observation_only'] === null ? null : json['for_observation_only'],
    };
}

export function MatrixCareAdmissionDemographicsToJSON(json: any): MatrixCareAdmissionDemographics {
    return MatrixCareAdmissionDemographicsToJSONTyped(json, false);
}

export function MatrixCareAdmissionDemographicsToJSONTyped(value?: MatrixCareAdmissionDemographics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['first_name'],
        'middle_name': value['middle_name'],
        'last_name': value['last_name'],
        'suffix': value['suffix'],
        'nickname': value['nickname'],
        'preferred_pronouns': value['preferred_pronouns'],
        'medical_record': value['medical_record'],
        'formatted_ssn': value['formatted_ssn'],
        'date_of_birth': value['date_of_birth'],
        'address_line': value['address_line'],
        'apt_or_suite': value['apt_or_suite'],
        'city': value['city'],
        'state_code': value['state_code'],
        'zip_code': value['zip_code'],
        'country': value['country'],
        'email': value['email'],
        'home_phone': value['home_phone'],
        'mobile_phone': value['mobile_phone'],
        'gender': value['gender'],
        'gender_identity': value['gender_identity'],
        'sexual_orientation': value['sexual_orientation'],
        'lives_alone': value['lives_alone'],
        'marital_status': value['marital_status'],
        'religion': value['religion'],
        'races': value['races'],
        'ethnicities': value['ethnicities'],
        'referral_date': value['referral_date'],
        'scheduled_soc_date': value['scheduled_soc_date'],
        'physician_ordered_soc_date': value['physician_ordered_soc_date'],
        'facility_discharge_date': value['facility_discharge_date'],
        'facility_discharge_type': value['facility_discharge_type'],
        'referral_source': value['referral_source'],
        'is_short_stay_acute_hospital': value['is_short_stay_acute_hospital'],
        'for_observation_only': value['for_observation_only'],
    };
}

